import * as React from 'react';

import * as Yup from 'yup';
import {
	Field, FieldProps,
} from 'formik';

import { Chat } from '@common/react/components/Chat/Chat';
import Button from '@common/react/components/Forms/Button';
import { useChatSettingsProviderContext } from '@common/react/components/Chat/ChatSettingsProvider';
import { simpleStringValidator } from '@common/react/utils/validationHelpers';
import { ItemProvider } from '@common/react/components/Core/ItemProvider/ItemProvider';
import { ItemEditor } from '@common/react/components/Core/ItemEditor/ItemEditor';
import { useModal } from '@common/react/components/Modal/ModalContextProvider';

const validationSchema = Yup.object().shape({
	name: simpleStringValidator,
});

interface ChatNameEditorProps {
	render: (show: () => void) => void;
	onSave: (chat: Chat) => void;
	chat: Partial<Omit<Chat, 'id' | 'name'>> & {id: number, name: string};
}

interface ChatNameEditorState {
	popupShow: boolean;
}

interface FormValues {
	id: number;
	name: string;
}

const ChatNameEditor: React.FC<ChatNameEditorProps> = (props) => {
	const [state, setState] = React.useState<ChatNameEditorState>({
		popupShow: false,
	});
	const { openErrorMessage, renderModal } = useModal();

	const { state: { requests } } = useChatSettingsProviderContext();

	const showPopup = () => setState((prev) => ({ ...prev, popupShow: true }));
	const popupHide = () => setState((prev) => ({ ...prev, popupShow: false }));

	return <>
		{props.render(showPopup)}
		{renderModal(state.popupShow, popupHide, {
			title: 'Edit Chat Name',
			destroyOnHidden: true,
			width: 450,
			footer: null,
			children: <ItemProvider
				id={props.chat.id}
				loadRequest={requests.chat}
				saveRequest={requests.chat}
				validationSchema={validationSchema}
				add={{
					id: props.chat.id,
					name: props.chat.name || '',
				} as FormValues}
				item={{
					id: props.chat.id,
					name: props.chat.name || '',
				} as FormValues}
				skipInitLoad
				onSaveRequestError={openErrorMessage}
			>
				<ItemEditor<FormValues>
					afterSubmit={({ res: result }) => {
						setState((prev) => ({
							popupShow: false,
						}));

						props.onSave({ ...result, ...props.chat, name: result.name } as Chat);
					}}
					showMessages={false}
					formProps={{
						id: 'new-chat-message',
					}}
					edit={({ formikBag, state: { loading } }) => {
						return <>
							<div className="row">
								<Field name="name">
									{({ field }: FieldProps<string, FormValues>) =>
										<div className="form-group col-sm-12">
											<div className="is-relative input-group">
												<input type="text" className="form-control" {...field} />
												<div className="input-group-btn">
													<Button
														disabled={!(field.value?.trim())}
														isLoading={loading}
														className="btn btn-primary"
													>
														Save
													</Button>
												</div>
											</div>
										</div>
									}
								</Field>
							</div>
						</>;
					}}
				/>
			</ItemProvider>,
		})}
	</>;
};

export default ChatNameEditor;
